import { onScroll } from "../modules/requestAnimationFrame";
import { inView, getPercentLocOfView, getRect, myTopAboveViewTop, myBottomAboveViewBottom } from "../modules/inView";
import animations from "../modules/animeTimelines";

let bands = document.getElementsByClassName("anim");
let timelines = [];

const getAnimPreset = el => el.getAttribute("data-anim-preset") || "";

const clamp = (val, min, max) => (val > max ? max : val < min ? min : val);

const getScrollPercentOfRange = (el, top, bottom) => {
    const topLoc = getRect(el).top;
    const start = getPercentLocOfView(top);
    const end = getPercentLocOfView(bottom);
    const range = end - start;
    return clamp((topLoc - start) / range, 0, 1);
};

const setInViewClasses = el => {
    if (myTopAboveViewTop(el)) {
        el.classList.add("inview--top-top");
    } else {
        el.classList.remove("inview--top-top");
    }

    if (myBottomAboveViewBottom(el)) {
        el.classList.add("inview--bottom-bottom");
    } else {
        el.classList.remove("inview--bottom-bottom");
    }
};

const animTick = () => {
    timelines.forEach(function(timeline) {
        let el = timeline.el;

        if (inView(el)) {
            setInViewClasses(el);

            timeline.timelines.forEach(function(animItem) {
                const percent = getScrollPercentOfRange(el, animItem.start, animItem.end);
                animItem.timeline.seek(animItem.timeline.duration * percent);
            });
        }
    });
};

const init = () => {
    if (bands.length > 0) {
        bands.forEach(el => {
            // test for 'data-anim-preset' on dom element. If we have a match in animation then register the animation
            let animPreset = getAnimPreset(el);

            if (animations[animPreset]) {
                timelines.push(animations[animPreset](el));
            }
        });

        onScroll(animTick);
    }
};

export default { init };
